module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('discount-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.discount.name
    },
    model: {
      value: (_vm.$attrs.discount.name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.discount, "name", $$v)
      },
      expression: "$attrs.discount.name"
    }
  }), _vm._v(" "), _c('amount-field', {
    attrs: {
      "error": _vm.$attrs.errors.discount.amount
    },
    model: {
      value: (_vm.$attrs.discount.amount),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.discount, "amount", $$v)
      },
      expression: "$attrs.discount.amount"
    }
  }), _vm._v(" "), _c('start-date-field', {
    attrs: {
      "error": _vm.$attrs.errors.discount.start_date
    },
    model: {
      value: (_vm.$attrs.discount.start_date),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.discount, "start_date", $$v)
      },
      expression: "$attrs.discount.start_date"
    }
  }), _vm._v(" "), _c('end-date-field', {
    attrs: {
      "error": _vm.$attrs.errors.discount.end_date
    },
    model: {
      value: (_vm.$attrs.discount.end_date),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.discount, "end_date", $$v)
      },
      expression: "$attrs.discount.end_date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d503ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/discount/DiscountBlankForm.vue
// module id = 599
// module chunks = 0